import { defineComponent as _defineComponent } from 'vue'
import { SecurityItemsKeys } from '@/enum/SecurityItems';
import { AloDbFleet, isAloDbFleetCoverage, isAloDbFleetFormation } from '@/models/alodb/AloDbFleet'
 
  import FleetState from './FleetState.vue'
import store from '@/store';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'FleetSearchLine',
  props: {
  fleet: {
    type: AloDbFleet,
    required: true
  }
},
  setup(__props) {

const props = __props;




const fleetIco = computed(() => {
    return isAloDbFleetCoverage(props.fleet)  ? 'mdi-select-group' 
          :isAloDbFleetFormation(props.fleet) ? 'mdi-vector-circle' 
                                              : 'mdi-multicast'
  })




 const accesPilotReachDetail = computed(() => {
    return  props.fleet.security[SecurityItemsKeys.PILOT_REACH_DETAIL]
}) 

const detailVisibility = computed(() => {
    return {}
})


return { __sfc: true,props, fleetIco, accesPilotReachDetail, detailVisibility, FleetState }
}

})